import toast from "react-hot-toast";
import * as api from "../Api";

// create a  new asset
export const getLocation = () => async (dispatch) => {
  try {
    const { data } = await api.fetchLocations();
    dispatch({ type: "FETCH_ALL_LOCATION", payload: data });
  } catch (error) {}
};

export const createLocation = (postData) => async (dispatch) => {
  let creatingIdCatId;

  try {
    creatingIdCatId = toast.loading("Creating Location...");
    const { data } = await api.CompanyLocation(postData);
    dispatch({ type: "CREATE_LOCATION", payload: data });
    toast.remove(creatingIdCatId);
    toast.success("Location created successfully");
  } catch (error) {
    toast.remove(creatingIdCatId);
    toast.error(error.message);
  }
};
